import { useEffect, useState } from 'react';
import { useMatch, useNavigate } from 'react-router';
import type { IdentityProviderDrawerMode } from './IdentityProviderDrawer';

const BASE_PATH = 'identity-providers';

export const useIdentityProviderDrawer = () => {
    const navigate = useNavigate();
    const newMatch = useMatch(`/${BASE_PATH}/new`);
    const editMatch = useMatch(`/${BASE_PATH}/:id`);

    const isNewUrl = !!newMatch;
    // /:id matches /new too, so the explicit /new check wins.
    const urlEditId = !isNewUrl ? (editMatch?.params.id ?? null) : null;

    const [drawerMode, setDrawerMode] = useState<IdentityProviderDrawerMode | null>(null);

    useEffect(() => {
        if (isNewUrl) {
            setDrawerMode({ type: 'create-idp' });
        } else if (urlEditId) {
            setDrawerMode({ type: 'edit-idp', identityProviderId: urlEditId });
        } else {
            setDrawerMode(null);
        }
    }, [isNewUrl, urlEditId]);

    const openCreate = () => navigate(`/${BASE_PATH}/new`);
    const openEdit = (id: string) => navigate(`/${BASE_PATH}/${id}`);
    const navigateToBase = () => navigate(`/${BASE_PATH}`);

    return { drawerMode, openCreate, openEdit, navigateToBase };
};
